import { render, staticRenderFns } from "./ManageRateDates.vue?vue&type=template&id=436097d4"
import script from "./ManageRateDates.vue?vue&type=script&lang=ts"
export * from "./ManageRateDates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports